export default __webpack_public_path__ + "5c2810dd829e67b2cb8bdc5a0388a0f5.png";